module.exports = __webpack_public_path__ + "UX40.png?f1d62832bb24fb5b6c740f2780fa9594";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX40.png
// module id = 91
// module chunks = 0